import { GET_ADDCOMPANY, GET_COMPANYLIST, GET_COMPANY_DETAILS, GET_GSTCOMPANY ,GET_PARENT_COMPANYLIST,GET_UPDATECOMPANY, GET_UPDATEGSTCOMPANY,GET_PARENTCOMPANYDETAILS} from "resources/actionTypes";


export function fetchCompanyList(companyData, searchKey) {

  const data = {
    companyData: companyData,
    searchKey: searchKey
  }
  return {
    type: GET_COMPANYLIST.GET_COMPANYLIST_REQUESTED,
    payload: data
  };
}

export function clearCompanyList() {
  return {
    type: GET_COMPANYLIST.CLEAR_COMPANYLIST
  };
}

export function fetchParentCompanys(companyData, searchKey) {

  const data = {
    companyData: companyData,
    searchKey: searchKey
  }
  return {
    type: GET_PARENT_COMPANYLIST.GET_PARENT_COMPANYLIST_REQUESTED,
    payload: data
  };

}

export function fetchCompanyDetails(id) {
  const data = {
    id: id,
  }
  return {
    type: GET_COMPANY_DETAILS.GET_COMPANY_DETAILS_REQUESTED,
    payload: data
  };
}

export function clearCompanyDetails() {
  return {
    type: GET_COMPANY_DETAILS.CLEAR_COMPANY_DETAILS,
  };
}

export function addCompany(companyOnboardData, setContractDetails, navigate) {

  const data = {
    companyOnboardData: companyOnboardData,
    setContractDetails: setContractDetails,
    navigate: navigate
  }
  return {
    type: GET_ADDCOMPANY.GET_ADDCOMPANY_REQUESTED,
    payload: data
  };
}

export function updateCompany(updateCompanyOnboardData, payloadObj) {

  const data = {
    updateCompanyOnboardData: updateCompanyOnboardData,
    payloadObj: payloadObj,
  }
  return {
    type: GET_UPDATECOMPANY.GET_UPDATECOMPANY_REQUESTED,
    payload: data
  };
}

export function deleteCompany(companyId, navigate) {
  const data = {
    companyId: companyId,
    navigate: navigate
  }
  return {
    type: GET_ADDCOMPANY.GET_ADDCOMPANY_REQUESTED,
    payload: data,
    isDelete: true
  };
}

export function addCompanyGst(companyGstData, navigate) {
  const data = {
  companyGstData: companyGstData,
  navigate: navigate
  }
  return{
    type: GET_GSTCOMPANY.GET_GSTCOMPANY_REQUESTED,
    payload:data
  };
}

export function updateCompanyGst(updateCompanyGstData, navigate) {
  const data = {
    updateCompanyGstData: updateCompanyGstData,
  navigate: navigate
  }
  return{
    type: GET_UPDATEGSTCOMPANY.GET_UPDATEGSTCOMPANY_REQUESTED,
    payload:data
  };
}

export function fetchParentCompanyDetails(id) {
  const data = {
    id: id,
  }
  return {
    type: GET_PARENTCOMPANYDETAILS.GET_PARENTCOMPANYDETAILS_REQUESTED,
    payload: data
  };
}